var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEtherscanUnverified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 427321101"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    d: "M2.4981 6.20643C2.4981 5.92947 2.72562 5.70195 3.0021 5.70195H3.85218C4.12914 5.70195 4.36626 5.92947 4.36626 6.21651V9.42243C4.46514 9.39267 4.5837 9.36291 4.72242 9.33315C4.9101 9.28371 5.04882 9.11571 5.04882 8.91747V4.93971C5.04882 4.66275 5.27634 4.42515 5.5629 4.42515H6.41298C6.68994 4.42515 6.92706 4.65267 6.92706 4.93971V8.63091C6.92706 8.63091 7.1349 8.54163 7.34226 8.45283C7.50066 8.38371 7.59954 8.23539 7.59954 8.05683V3.65379C7.59954 3.37683 7.82706 3.13923 8.10402 3.13923H8.9541C9.23106 3.13923 9.45858 3.36675 9.45858 3.65379V7.28547C10.1901 6.75123 10.9418 6.10803 11.5351 5.33619C11.7131 5.10867 11.7626 4.81155 11.6637 4.53459C10.576 1.40787 7.15554 -0.254848 4.03122 0.833792C0.906903 1.92243 -0.753897 5.34579 0.333303 8.47299C0.451863 8.82915 0.610263 9.16563 0.797943 9.49203C0.946263 9.74931 1.22322 9.89763 1.51986 9.86787C1.67826 9.85779 1.87602 9.83811 2.12274 9.80835C2.34018 9.78867 2.49858 9.60051 2.49858 9.38259L2.4981 6.20643Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M2.47794 11.3519C5.1573 13.3012 8.90466 12.7074 10.852 10.0261C11.5936 8.997 11.9987 7.76005 11.9987 6.49381C11.9987 6.35509 11.9887 6.21684 11.9791 6.07812C9.79458 9.35316 5.75058 10.8868 2.47794 11.3519Z",
    fill: "#666666"
  })))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 149",
    cx: 13,
    cy: 7.5,
    r: 4.5,
    fill: "#E45C51",
    stroke: "#202124"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtherscanUnverified);
export default __webpack_public_path__ + "static/media/etherscan-unverified.d36e14320d54a24ed981b8fc8783fc4d.svg";
export { ForwardRef as ReactComponent };